export default __webpack_public_path__ + "static/truvelo-86331a2da76cb59dc391db65f36d7d9b.png";